import { IAppState } from '../../redux';

export function selectIsWithoutMinimalBet(state: IAppState): boolean {
  return state.publishTerms.withoutMinimalBet;
}
